import React, { useContext } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { FormDataContext } from '../../contexts/FormDataContext';

export const Submit = ({preferencesSaving}) => {

  const {
    preferencesFormDisabled,
    isFormCompleted,
  } = useContext(FormDataContext);

  return (
    <Box align="center" sx={{marginTop: '15px'}}>
      <Button
        type="submit"
        variant="contained"
        size="large"
        sx={{padding: '12px 50px'}}
        disabled={preferencesFormDisabled || preferencesSaving}
        startIcon={preferencesSaving ? <CircularProgress size={24} color="inherit" /> : null}
      >
        {isFormCompleted
          ? <>{preferencesSaving ? 'Saving preferences...' : 'Save preferences'}</>
          : <>{preferencesSaving ? 'Saving preferences...' : 'Submit'}</>
        }

      </Button>
      <Typography sx={{marginY: '15px'}}>
        You must be a U.S. Citizen to be considered for civilian employment. I understand that by
          selecting “SUBMIT” I am giving my permission to be informed about future opportunities.
      </Typography>
    </Box>
  );
};